import { render, staticRenderFns } from "./CurrencySelector.vue?vue&type=template&id=59ad1796"
import script from "./CurrencySelector.vue?vue&type=script&lang=js"
export * from "./CurrencySelector.vue?vue&type=script&lang=js"
import style0 from "./CurrencySelector.vue?vue&type=style&index=0&id=59ad1796&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports